import { useContext, useEffect } from "react";
import PageTemplate from "../components/BaseComponents/PageTemplate/PageTemplate";
import { LoadingSpinner } from "../components/BaseComponents";
import usePublicApi from "../hooks/usePublicApi";
import { useNavigate } from "react-router-dom";
import routes from "../components/Router/routes";
import { markLogoutNotConfirmed } from "../lib/utils";
import { performLogoutRequest } from "../lib/logout";
import { userContext } from "../context/UserContext";

function Logout() {
    const publicApi = usePublicApi();
    const navigate = useNavigate();
    const { clearUserData } = useContext(userContext);

    useEffect(() => {
        const run = async () => {
            try {
                // Issue #759 (final review F1): the CSRF fetch and the POST are both bounded by
                // the same timeout inside performLogoutRequest - see lib/logout.ts.
                await performLogoutRequest(publicApi);
            } catch (err: any) {
                // Issue #759: best-effort - the server-side session will also expire on its own,
                // but the client-side state below is the actual data-leak boundary and must
                // always be cleared, even if this call fails (offline, CSRF mismatch, 5xx, or a
                // request that never settled at all - see withTimeout above).
                console.error('Failed to notify the server of logout, status:', err?.status)
                markLogoutNotConfirmed();
            } finally {
                clearUserData();
                navigate(routes.publicLogin.path);
            }
        }
        run();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <PageTemplate>
            <LoadingSpinner />
        </PageTemplate>
    )
}

export default Logout;
